import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { ItemVisual } from '../components/ItemVisual';
import { audio } from '../core/audio';
import { recordSkill } from '../core/storage';

export function FindPair({ activity, onComplete }) {
  const [cards] = useState(() => {
    const c = activity.pairs.flatMap((p, i) => [
      { key: `${p.id}-a`, item: p, pair: i }, { key: `${p.id}-b`, item: p, pair: i }]);
    return c.sort(() => Math.random() - 0.5);
  });
  const [open, setOpen] = useState([]);
  const [matched, setMatched] = useState([]);
  const stats = useRef({ attempts: 0 });
  const busy = useRef(false);

  useEffect(() => { const t = setTimeout(() => audio.playVoice(activity.voice), 400); return () => clearTimeout(t); }, [activity.id, activity.voice]);

  const flip = (key) => {
    if (busy.current || open.includes(key) || matched.includes(key)) return;
    audio.playSfx('tap');
    const no = [...open, key];
    setOpen(no);
    if (no.length === 2) {
      busy.current = true;
      stats.current.attempts += 1;
      const [a, b] = no.map((k) => cards.find((c) => c.key === k));
      setTimeout(async () => {
        if (a.pair === b.pair) {
          audio.playSfx('correct');
          recordSkill(activity.skill, true);
          const nm = [...matched, a.key, b.key];
          setMatched(nm);
          setOpen([]);
          busy.current = false;
          if (nm.length === cards.length) {
            await audio.playVoice('correct1');
            onComplete({ id: activity.id, correct: true, attempts: stats.current.attempts, hints: 0, skill: activity.skill });
          }
        } else {
          audio.playSfx('retry');
          recordSkill(activity.skill, false);
          setOpen([]);
          busy.current = false;
        }
      }, 900);
    }
  };

  return (
    <div className="flex-1 flex items-center justify-center px-5" data-testid={`activity-${activity.id}`}>
      <div className="grid grid-cols-2 gap-5">
        {cards.map((c) => {
          const faceUp = open.includes(c.key) || matched.includes(c.key);
          return (
            <motion.button key={c.key} data-testid={`card-${c.key}`} whileTap={{ scale: 0.94 }}
              onClick={() => flip(c.key)}
              className="rounded-[1.8rem] w-[110px] h-[110px] flex items-center justify-center"
              style={{
                background: faceUp ? 'rgba(255,255,255,0.9)' : '#FFD166',
                border: '5px solid #fff',
                boxShadow: matched.includes(c.key) ? '0 0 0 5px #4ADE80AA' : 'inset 0 -6px 0 rgba(0,0,0,0.1), 0 10px 22px rgba(29,53,87,0.16)',
              }}>
              {faceUp ? <ItemVisual item={c.item} size={84} /> : <span className="text-4xl font-heading text-navy/60">?</span>}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
